import { render, staticRenderFns } from "./PopupCarrier.vue?vue&type=template&id=2cf9c784&scoped=true&"
import script from "./PopupCarrier.vue?vue&type=script&lang=js&"
export * from "./PopupCarrier.vue?vue&type=script&lang=js&"
import style0 from "./PopupCarrier.vue?vue&type=style&index=0&id=2cf9c784&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf9c784",
  null
  
)

export default component.exports